
export const routeName = {
  main: {
    home: "/",
    organization: "/organization",
    organizationDetail: "/organization/:id",
    pollVote: "/poll-vote-website",
    galleryList: "/gallery",
    galleryDetail: "/gallery/:id_gallery",
    pressRelease: "/press-release",
    pressReleaseDetail: "/press-release/:id_content",
    contentDetail: "/content/:content_no",
    admission: "/admissions",
    activity: "/activity",
    activityDetail: "/activity/:id",
  },
  authentication: {
    login_member: "/login-member",
    login: "/login",
    register: "/register",
  },
  e_library: {
    books: "/books",
    books_list: "/books-list",
    books_detail: "/books-detail/:id",
    books_borrow: "/books-borrow-list",
    books_shop_cart: "/books-shop-cart",
    search_global: "/e-library-search-global",

    e_books: "/e-books",
    e_books_list: "/e-books/list",
    e_books_detail: "/e-books/:id",

    journal: "/journal",
    journal_list: "/journal/list",
    journal_detail: "/journal/:id",

    the_sis: "/the-sis",
    the_sis_list: "/the-sis/list",
    the_sis_detail: "/the-sis/:id",

    audio_book: "/audio_book",
    audio_book_list: "/audio_book/list",
    audio_book_detail: "/audio_book/:id",

    podcast: "/podcast",
    podcast_list: "/podcast/list",
    podcast_detail: "/podcast/:id",

    video: "/video",
    video_list: "/video/list",
    video_detail: "/video/:id",

    manage_books: "/e-library/manage-books",
    manage_books_detail: "/e-library/manage-books/:id",
    manage_books_view: "/e-library/manage-books/:id/view",
    manage_books_create: "/e-library/manage-books/create",
    manage_e_books: "/e-library/manage-e-books",
    manage_e_books_detail: "/e-library/manage-e-books/:id",
    manage_e_books_view: "/e-library/manage-e-books/:id/view",
    manage_e_books_create: "/e-library/manage-e-books/create",
    manage_the_ses: "/e-library/manage-the-ses",
    manage_the_ses_detail: "/e-library/manage-the-ses/:id",
    manage_the_ses_view: "/e-library/manage-the-ses/:id/view",
    manage_the_ses_create: "/e-library/manage-the-ses/create",
    manage_journal: "/e-library/manage-journal",
    manage_journal_detail: "/e-library/manage-journal/:id",
    manage_journal_view: "/e-library/manage-journal/:id/view",
    manage_journal_create: "/e-library/manage-journal/create",
    manage_podcast: "/e-library/manage-podcast",
    manage_podcast_detail: "/e-library/manage-podcast/:id",
    manage_podcast_view: "/e-library/manage-podcast/:id/view",
    manage_podcast_create: "/e-library/manage-podcast/create",
    manage_audio_book: "/e-library/manage-audio-book",
    manage_audio_book_detail: "/e-library/manage-audio-book/:id",
    manage_audio_book_view: "/e-library/manage-audio-book/:id/view",
    manage_audio_book_create: "/e-library/manage-audio-book/create",
    manage_videos: "/e-library/manage-videos",
    manage_videos_detail: "/e-library/manage-videos/:id",
    manage_videos_view: "/e-library/manage-videos/:id/view",
    manage_videos_create: "/e-library/manage-videos/create",

    manage_library_type: "/e-library/manage-library-type",
    manage_library_author: "/e-library/manage-library-author",
    manage_library_banner: "/e-library/manage-library-banner",
    manage_payment_channels: "/e-library/payment_channels",
    manage_report: "/e-library/manage-report",
    manage_orders: "/e-library/manage-orders",
    manage_orders_detail: "/e-library/manage-orders/:id",
    manage_orders_view: "/e-library/manage-orders/:id/view",
    manage_borrow: "/e-library/manage-borrow",
    manage_borrow_detail: "/e-library/manage-borrow/:id",
    manage_borrow_view: "/e-library/manage-borrow/:id/view",

  },
  admission: {
    list_applicants: "/list-applicants",
    applicants_detail: "/list-applicants/:id",
    manage_exams: "/manage-exams",
    manage_exams_add: "/manage-exams/add",
    manage_exams_detail: "/manage-exams/:id",
    manage_exams_view: "/manage-exams/:id/view",
    period_examination: "/period-examination",
    period_examination_add: "/period-examination/add",
    period_examination_detail: "/period-examination/:id",
    admission_exam_detail:
      "/period-examination/:id/admission-exam/:id_period_examination_student/:id_admission_student",
    admission_exam_view:
      "/period-examination/:id/admission-exam/:id_period_examination_student/:id_admission_student/view",
    period_examination_view: "/period-examination/:id/view",
    interview_student: "/interview-student",
    interview_student_detail: "/interview-student/:id",
    interview_student_view: "/interview-student/:id/view",
    term_payment: "/term-payment",
    term_payment_detail: "/term-payment/:id",
    term_payment_view: "/term-payment/:id/view",
    student_registration: "/student-registration",
    student_registration_view: "/student-registration/:id/view",
    student_registration_information: "/student-registration-information",
    student_registration_information_view:
      "/student-registration-information/:id/view",
    student_registration_information_detail:
      "/student-registration-information/:id",
    student_registration_information_education:
      "/student-registration-information/:id/education/:id_student_educational",
    student_registration_information_education_view:
      "/student-registration-information/:id/education/:id_student_educational/view",
    student_registration_information_term_fees:
      "/student-registration-information/:id/term-fees/:id_student_term_payment",
    LevelFacultyManagement: "/level-faculty-management",
    ManageAcademicYear: "/manage-academic-year",
    SetupCourseOpening: "/setup-course-opening",
    SetupCourseOpeningView: "/setup-course-opening/:id/view",
    SetupCourseOpeningDetail: "/setup-course-opening/:id",
    SetTuitionFees: "/set-tuition-fees",
    SetTuitionFeesView: "/set-tuition-fees/:id/view",
    CourseTuitionFees: "/set-tuition-fees/:id_course_of_study",
    // SetTuitionFeesDetail: "/set-tuition-fees/:id",
    ManagePayment: "/manage-payment",
    ManagePaymentAdd: "/manage-payment/add",
    ManagePaymentView: "/manage-payment/:id/view",
    ManagePaymentDetail: "/manage-payment/:id",
    ManagePDPA: "/manage-PDPA",

    IBSCOnlineAdmission: "/IBSC-online-admission",
    CheckPDPA: "/IBSC-online-admission/check-PDPA",
    AdmissionForm: "/IBSC-online-admission/admission-form",
    AdmissionFormUpdte: "/IBSC-online-admission/admission-form/:id",
    HistoryOnlineAdmission: "/history-online-Admission",
    AdmissionDetail: "/history-online-Admission/admission-detail/:id",
    FormExamination:
      "/history-online-Admission/admission-detail/:id/form-examination/:id_period_examination_student",
  },
  cms_website: {
    dashboard: "/manage-website/dashboard",
    intro: "/intro",
    profile_employee: "/profile-employee/:id",
    website_structure_content: "/website-structure-content",
    website_structure_content_view: "/website-structure-content/:id/view",
    website_structure_content_detail: "/website-structure-content/:id",
    website_structure_content_create: "/website-structure-content/create",
    website_structure_footer: "/website-structure-footer",
    website_structure_contact: "/website-structure-contact",
    website_structure_header: "/website-structure-header",
    website_structure_menu_header: "/website-structure-menu-header",
    website_structure_banner_slide_list: "/website-structure-banner-slide-list",
    website_structure_banner_slide: "/website-structure-banner-slide",
    website_structure_banner_slide_view:
      "/website-structure-banner-slide/:id/view",
    website_structure_banner_slide_detail:
      "/website-structure-banner-slide/:id",
    website_structure_banner_slide_create:
      "/website-structure-banner-slide/create",
    calendar_activity: "/calendar-activity",
    calendar_activity_detail: "/calendar-activity/:id",
    calendar_activity_create: "/calendar-activity/create",
    calendar_activity_view: "/calendar-activity/:id/view",
    content_news: "/content-news",
    content_news_view: "/content-news/:id/view",
    content_news_detail: "/content-news/:id",
    content_news_create: "/content-news/create",

    admission_form: "/admission-form",

    poll_vote: "/poll-vote",
    poll_vote_detail: "/poll-vote/:id",
    poll_vote_view: "/poll-vote/:id/view",
    poll_vote_create: "/poll-vote/create",
    setting_manage_file: "/setting-manage-file",
    collection_image: "/collection-image",
    collection_image_detail: "/collection-image/:id",
    collection_image_view: "/collection-image/:id/view",
    collection_image_create: "/collection-image/create",
    collection_vdo: "/collection-vdo",
    collection_vdo_detail: "/collection-vdo/:id",
    collection_vdo_create: "/collection-vdo/create",
    collection_vdo_view: "/collection-vdo/:id/view",
    setting_manage_tag: "/setting-manage-tags",
    LevelFacultyManagement: "/level-faculty-management",

    GalleryTypeManagement: "/gallery-type-management",
    ActivityCategoriesManagement: "/activity-categories-management",
    TagManagement: "/tag-management",
    NewsCategoriesManagement: "/news-categories-management",
    PollCategoriesManagement: "/poll-categories-management",
    permission: "/setting/permission",
    permissionCreate: "/setting/permission/create",
    permissionDetail: "/setting/permission/:id",
    permissionDetailView: "/setting/permission/:id/view",

    collaborationNetwork: "/collaboration-network",
    comment: "/comment",
    loginLog: "/login-log",

    employee: "/setting/employee",
    employeeAdd: "/setting/employee/add",
    employeeView: "/setting/employee/:id/view",
    employeeDetail: "/setting/employee/:id",
  },
  cms: {
    ListOfApplicants: "/list-of-applicants",
    Notifications: "/notifications",
    EntranceExamination: "/entrance-examination",
    PersonnelManagement: "/personnel-management",
    PersonnelManagementDetail: "/personnel-management-detail",
    PersonnelManagementDetailById: "/personnel-management-detail/:id",
    PersonnelManagementDetailViewById: "/personnel-management-detail/view/:id",
    PersonnelManagementDetailExportById:
      "/personnel-management-detail/export/pdf/:id/:token",
    ManageStudents: "/manage-students",
    ManageStudentDetail: "/manage-students/detail/:id",
    ManageStudentEducationInfo: "/manage-students/education-info/term/:id",
    ManageJobTitles: "/manage-job-titles",
    OrganizationChartManagement: "/organization-chart-management",
    OnlineLeaveSubmission: "/online-leave-submission",
    OnlineLeaveSubmissionCreate: "/online-leave-submission/create",
    OnlineLeaveSubmissionDetail: "/online-leave-submission/detail/:id",
    OnlineLeaveSubmissionRequest: "/manage-online-leave-submission",
    OnlineLeaveSubmissionApprove: "/manage-online-leave-submission/:id/approve",
    PrintOnlineLeaveSubmission: "/print/online-leave-submission/:id/:token",
    SettingLeaveDay: "/setting-leave-day",
    SettingLeaveDayDetail: "/setting-leave-day/:id/detail",
    ManageLeaveType: "/manage-leave-type",
    ManageLeaveTypeCreate: "/manage-leave-type/create",
    ManageLeaveTypeUpdate: "/manage-leave-type/:id/update",

    TimeRecordSystem: "/time-record-system",
    TimeRecordSystemAll: "/time-record-system/all",
    ManageTimeRecordSystem: "/manage-time-record-system",
    ManageTimeRecordSystemDetail: "/manage-time-record-system/:id/detail",
    LoginHistory: "/login-history",

    ManageClassRoom: "/manage-class-room",
    CreateClassRoom: "/manage-class-room/create",
    UpdateClassRoom: "/manage-class-room/:id/update",

    ManageEvaluationForm: "/manage-evaluation-form",
    CreateEvaluationForm: "/manage-evaluation-form/create",
    UpdateEvaluationForm: "/manage-evaluation-form/:id",

    ManageEvaluationFormUpdate: "/manage-evaluation-form/:id",

    AdvisorSystem: "/advisor-system",
    manageAdvisors: "/advisor-system/manage-advisor",
    ManageAdvisorDetail: "/advisor-system/manage-advisor/:id/detail",
    manageAdvisorRequestDetail:
      "/advisor-system/manage-advisor/:id/request/detail",
    AdvisorConsultationDetail:
      "/advisor-system/manage-advisor/consultation-detail/:id",

    manageConsultationTypes: "/advisor-system/manage-consultation-type",
    manageDocuments: "/advisor-system/manage-documents",
    consultingReport: "/advisor-system/consulting-report",
    consultingReportDetail: "/advisor-system/consulting-report/:id",
    PrintReportConsultation:
      "/print/advisor-system/consulting-report/:id/:token",

    courseManagement: "/course-management",
    // HISTORY_USING_CLASS_SCHEDULE
    history_using_class_shedule: "/history-using-class-shedule",
    ManageMeetingCategories: "/manage-meeting-categories",
    ManageMeetingPositions: "/manage-meeting-positions",
    ManageSampleFiles: "/manage-sample-files",
    MeetingCalendar: "/manage-calendar",
    MeetingCaledarCreate: "/manage-calendar-create",
    MeetingCaledarDetail: "/manage-calendar-detail/:id",
    AddMeetingParticipants:
      "/manage-calendar-detail/:id/add-meeting-participants",
    DetailMeetingParticipants:
      "/manage-calendar-detail/:id/meeting-participants/:id_participant",
    ViewMeetingParticipants:
      "/manage-calendar-detail/:id/meeting-participants/:id_participant?mode=VIEW",
    AddAgenda: "/manage-calendar-detail/:id/add-agenda",
    AddSubAgenda: "/manage-calendar-detail/:id/add-sub-agenda/:idAgenda",
    DetailAgenda: "/manage-calendar-detail/:id/detail-agenda",
    DetailSubAgenda: "/manage-calendar-detail/:id/detail-sub-agenda/:idAgenda",

    CourseofStudy: "/course-of-study",
    CourseOfStudyDetail: "/course-of-study-detail/:id",
    CourseOfStudyAddSubject: "/course-of-study-detail/:id/add-subject",
    CourseOfStudySubjectDetail: "/course-of-study-detail/:id/:idDetail",

    // ระบบร้องเรียน
    complaintSystem: "/complaint-system",
    complaintSystemDetail: "/complaint-system/:id",
    complaintSystemDetailView: "/complaint-system/:id/view",

    complaintsType: "/complaint-type",
    complaintsStatistics: "/complaint-statistics",

    // ระบบ edpex
    edPexDisplayPage: "/ed-pex/display-page",

    // จัดการข้อมูลคอร์สออนไลน์
    course_online_statistics: "/course-online-statistics",
    course_online_tags: "/course-online-tags",
    course_online_course_type: "/course-online-course-type",
    course_online_payment: "/course-online-payment",
    course_online_payment_detail: "/course-online-payment/:id",
    course_online_payment_view: "/course-online-payment/:id/view",
    course_online_payment_channels: "/course-online-payment-channels",
    course_online_surveys: "/course-online-surveys",
    course_online_surveys_create: "/course-online-surveys/create",
    course_online_surveys_detail: "/course-online-surveys/:id",
    course_online_surveys_view: "/course-online-surveys/:id/view",
    course_online_quiz: "/course-online-quiz",
    course_online_quiz_create: "/course-online-quiz/create",
    course_online_quiz_detail: "/course-online-quiz/:id",
    course_online_quiz_view: "/course-online-quiz/:id/view",

    OnlineCourseManagement: "/course-online-management",
    OnlineCourseManagementCreate: "/course-online-management/add",
    OnlineCourseManagementDetail: "/course-online-management/:id",
    OnlineCourseManagementView: "/course-online-management/:id/view",
    OnlineCourseDiploma: "/course-online-diploma",
    OnlineCourseDiplomaCreate: "/course-online-diploma/add",
    OnlineCourseDiplomaDetail: "/course-online-diploma/:id",

    FileDiploma: "/file-diploma/:id",

    EThesisCategories: "/e-thesis-categories",
    EThesisType: "/e-thesis-type",
    RulesRegulations: "/rules-regulations",
    EThesisLibrary: "/e-thesis-library",
    AddEThesisLibrary: "/e-thesis-library/add",
    DetailEThesisLibrary: "/e-thesis-library/:id",
    ScheduleCalenda: "/e-thesis-schedule-calenda",
    AddScheduleCalenda: "/e-thesis-schedule-calenda/add",
    ListExaminationDate: "/e-thesis-schedule-calenda/:id/list-examination-date",
    DetaiExamination:
      "/e-thesis-schedule-calenda/:id/examination/:id_examination_calendar_student",
    DetailScheduleCalenda: "/e-thesis-schedule-calenda/:id",
    EThesisProgress: "/e-thesis-progress",
    ListThesisProgress: "/e-thesis-progress/:id/list",
    DetailThesisProgress: "/e-thesis-progress/:id/:id_thesis_progress",
    EThesisHistory: "/e-thesis-history",
    //
    //
    BookingRoom: "/booking-room",
    BookingRoomCreate: "/booking-room/create",
    BookingRoomUpdate: "/booking-room/:id",
    BookingRoomView: "/booking-room/:id/view",

    BookingRoomRequestUpdate: "/booking-room-request-management/:id/update",
    BookingRoomRequestView: "/booking-room-request-management/:id/view",
    BookingRoomRequestContact: "/booking-room-request-management/:id/contact",
    //
    BookingRoomRequestMangement: "/booking-room-request-management",
    //
    BookingRoomManagement: "/booking-room-management",
    BookingRoomManagementCreate: "/booking-room-management/create",
    BookingRoomManagementUpdate: "/booking-room-management/:id/update",
    //
    BookingRoomDeviceManagement: "/booking-room-device-management",
    BookingRoomDeviceManagementForm: "/booking-room-device-management-form",
    //
    BookingRoomServiceFeesMangement: "/booking-room-fees-management",
    //
    BookingRoomPaymentChannelManagement:
      "/booking-room-payment-chanel-management",
    //
    BookingRoomUsageReports: "/booking-room-usage-report",
    //
    edpexResultDisplay: "/edpex-dashboard/result-display", // หน้าแสดงผล

    edpexResponsibleProjects: "/edpex-dashboard/responsible-projects", // โครงการ/กิจกรรม/งานที่รับผิดชอบ
    edpexResponsibleProjectsDetail:
      "/edpex-dashboard/responsible-projects/:id/detail", // โครงการ/กิจกรรม/งานที่รับผิดชอบ update
    edpexResponsibleProjectsComplete:
      "/edpex-dashboard/responsible-projects/:id/complete", // โครงการ/กิจกรรม/งานที่รับผิดชอบ update

    edpexAddResponsiblePerson: "/edpex-dashboard/add-responsible-person", // เพิ่มผู้รับผิดชอบ
    edpexAddProject: "/edpex-dashboard/add-project", // เพิ่มโครงการ/กิจกรรม/งาน
    edpexAddProjectCreate: "/edpex-dashboard/add-project/create", // เพิ่มโครงการ/กิจกรรม/งาน create
    edpexAddProjectDetail: "/edpex-dashboard/add-project/:id/detail", // เพิ่มโครงการ/กิจกรรม/งาน update

    edpexSpecialEditRequest: "/edpex-dashboard/special-edit-request", // การขอแก้ไขพิเศษ
    edpexSpecialEditRequestDetail:
      "/edpex-dashboard/special-edit-request/:id/detail", // การขอแก้ไขพิเศษ detail

    edpexCriteria: "/edpex-dashboard/edpex-criteria", // เกณฑ์คะแนน Edpex
    edpexMission: "/edpex-dashboard/mission", // พันธกิจ
    edpexSampleProjectData: "/edpex-dashboard/sample-project-data", // จัดการข้อมูลตัวอย่างการเพิ่มโครงการ
    edpexSampleSummaryData: "/edpex-dashboard/sample-summary-data", // จัดการข้อมูลตัวอย่างการสรุปผล

    // หน้าแสดงผล, โครงการ/กิจกรรม/งานที่รับผิดชอบ, เพิ่มผู้รับผิดชอบ, เพิ่มโครงการ/กิจกรรม/งาน, การขอแก้ไขพิเศษ, เกณฑ์คะแนน Edpex, พันธกิจ, จัดการข้อมูลตัวอย่างการเพิ่มโครงการ, จัดการข้อมูลตัวอย่างการสรุปผล
  },
  advisor: {
    SubjectTaught: "/subject-taught",
    SubjectTaughtDetail: "/subject-taught/:id/course-annual",
    SubjectTaughtCourseAnnualDetail: "/subject-taught/:id/course-annual-detail",
    //
    TeacherEvaluationScores: "/teacher-evaluation-scores",
    TeacherEvaluationScoresDetail: "/teacher-evaluation-scores/:id/detail",
    TeacherEvaluationScoresEmployeeDetail:
      "/teacher-evaluation-scores/:id/course-detail/:id_employee/employee",
    TeacherEvaluationScoreCourseEstimate:
      "/teacher-evaluation-scores/:id/course-annual-student-estimate",
    TeacherEvaluationScoreCourseEstimateDetail:
      "/teacher-evaluation-scores/:id/course-annual-student-estimate-detail",
    //
    EvaluationScoresFromStudents: "/evaluation-score-from-student",
    EvaluationScoresFromStudentsCourselist:
      "/evaluation-score-from-student/:id/course",
    EvaluationScoresFromStudentsDetailCourseEstimateDetail:
      "/evaluation-score-from-student/:id/estimate-detail",
    //
    manageAdvisorRequest: "/manage-advisor-request",
    advisorRequestDetail: "/manage-advisor-request/:id",
    studentConsultation: "/manage-student-consultaion",
    manageStudentConsultation: "/manage-student-consultaion/:id",
    //
  },
  student: {
    schedule: "/student-scheule",
    chooseAdvisor: "/choose-advisor",
    TransferAdvisor: "/transfer-advisor-request",
    TransferAdvisorRequest: "/transfer-advisor-request/:id",
    TransferAdvisorRequestHistory: "/transfer-advisor-request/history",
    TransferAdvisorRequestHistoryDetail:
      "/transfer-advisor-request/history/:id/detail",
    studentConsultation: "/student/request-consultation",
    createConsultation: "/student/request-consultation/create",
    updateConsultation: "/student/request-consultation/:id/update",
    votingEvaluation: "/student/request-consultation/:id/voting-evaluation",
  },
  students: {
    CourseofStudy: "/students/course-of-study",
    CourseOfStudyDetail:
      "/students/course-of-study-detail/:id/:id_academic_year",
    CourseDetail: "/students/course-detail/:id",
    EvaluateTeachers: "/students/evaluate-teachers/:id",
    EvaluateTeachersDetail: "/students/evaluate-teachers-detail/:id",
    MeetingCalendar: "/students/manage-calendar",
    MeetingCaledarDetail: "/students/manage-calendar-detail/:id",

    complaintSubmit: "/complaint-submit",
    complaintSubmitCreate: "/complaint-submit/create",
    complaintSubmitDetailView: "/complaint-submit/:id/view",
    complaintSubmitDetail: "/complaint-submit/:id",

    EThesisLibrary: "/students/e-thesis-library",
    DetailEThesisLibrary: "/students/e-thesis-library/:id",
    ScheduleCalenda: "/students/e-thesis-schedule-calenda",
    StudentsAddExaminationCalendar: "/students/examination-calenda/add",
    ListExaminationDate:
      "/students/e-thesis-schedule-calenda/:id/list-examination-date",
    DetailScheduleCalenda: "/students/e-thesis-schedule-calenda/:id",
    EThesisProgress: "/students/e-thesis-progress",
    StudentsAddThesisProgress: "/students/e-thesis-progress/add",
    StudentsDateilThesisProgress: "/students/e-thesis-progress/:id",
    RulesRegulations: "/students/rules-regulations",

    OnlineCourse: "/students/online-course",
    ListOnlineCourse: "/students/online-course/list",
    OnlineCourseDetail: "/students/online-course/:id",
    PaymentOnlineCourse: "/students/online-course/:id/payment",
    PaymentOnlineAllCourse: "/students/online-course/payment",
    ShoppingCart: "/students/online-course/cart",
    TakeLesson: "/students/online-course/:id/take-lesson",
    ExampleCourse: '/students/example-course/:id',
    MyOnlineCourse: "/my-course-online",
  },
  request_form: {
    manage_request: "/manage-request",
    manage_request_detail: "/manage-request/:id",
    manage_request_view: "/manage-request/:id/view",
    manage_request_forms: "/manage-request-forms",
    manage_request_form_add: "/manage-request-forms/add",
    manage_request_form_detail: "/manage-request-forms/:id",
    manage_request_form_view: "/manage-request-forms/:id/view",
    visa_request: "/visa-request",
    visa_request_create: "/visa-request-create",
    visa_request_detail: "/visa-request-detail/:id",
    visa_request_view: "/visa-request-detail/:id/view",
    manage_payment_channels_visa: "/visa-manage-payment-channels",
    visa_intendant: "/visa-intendant",
  },
  public: {
    leave_form: "/leave-form/:id/public",
    classroom_meeting_booking: "/classroom-meeting-booking",
    classroom_meeting_booking_create: "/classroom-meeting-booking/create",
    classroom_meeting_booking_detail: "/classroom-meeting-booking/:id",
    classroom_meeting_booking_view: "/classroom-meeting-booking/:id/view",
  }
};
